import { internalFetch, internalODataFetch, newJosnCall } from "./servicesHelpers";
import { STATUSES } from "../globals/workOrderStatus";
import moment from "moment";

const taskServices = {
    actions: {
        unassign: "unassignTask",
        enroute: "enroute",
        onsite: "onsite",
        complete: "completeTask",
        pendingBillingApproval: "pendingBillingApproval",
        followUp: "followUp",
    },

    getTasks: (token, vendorNumber, contractNumber, allStatus, creationDateObject, workOrderNumber, page = 0, size = parseInt(process.env.REACT_APP_FETCH_TASKS_PAGE_SIZE) || 500) => {
        const requestInit = {
            method: "PATCH", // *GET, POST, PUT, DELETE, etc.
            mode: "same-origin", // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        let payload = { contractorNumber: vendorNumber };
        let contractFilter = "";
        let contractQuery = "";
        if (contractNumber != null && contractNumber.length > 0) {
            contractNumber.forEach((el, index) => {
                let contractValue = index === contractNumber.length - 1 ? `${el}` : `${el},`;
                contractQuery += contractValue;
                // let filter =
                // index === contractNumber.length - 1
                //   ? `contractNumber/contractNumber eq '${el}'`
                //   : `contractNumber/contractNumber eq '${el}' or `;
                // contractFilter += filter;
            });
            payload["contractNumber"] = contractQuery;
        }
        let statusFilter = "";
        let statusQuery = "";
        if (allStatus !== null && allStatus.length > 0) {
            allStatus.forEach((el, index) => {
                let statusValue = index === allStatus.length - 1 ? `${el}` : `${el},`;
                statusQuery += statusValue;
                // let statusList =
                // index === allStatus.length - 1
                //   ? `FK_status eq ${Number(el)}`
                //   : `FK_status eq ${Number(el)} or `;
                //   statusFilter += statusList;
            });
            payload.status = statusQuery;
        }
        if (!workOrderNumber) {
            if (creationDateObject.fromDate !== "" && creationDateObject.fromDate !== null) {
                payload.fromDate = moment(creationDateObject.fromDate).format("YYYY-MM-DD");
            } else {
                payload.fromDate = moment(new Date()).add(-1, "year").format("YYYY-MM-DD");
            }
        }
        if (creationDateObject.toDate !== "" && creationDateObject.toDate !== null) {
            payload.toDate = moment(creationDateObject.toDate).format("YYYY-MM-DD");
        }
        if (workOrderNumber) {
            payload.workOrderNumber = workOrderNumber;
        }
        payload.page = page;
        payload.size = size;
        const allStatusFilter = `(contractorNumber eq '${vendorNumber}') and (${statusFilter}) and displayTask eq true `;
        const allFilers = `(contractorNumber eq '${vendorNumber}') and (${contractFilter}) and (${statusFilter}) and displayTask eq true `;
        const expand =
            "resourceAssignedTo,status,priority,workType,workActivity,contractNumber,locates,reasonCode,permits,plantType,workOrderDetail/followUps,workOrderDetail/followUps/followUpTpyeId,workOrderDetail/additionalAction,workOrderDetail/plantTypeDetails,workOrderDetail/jobClassification,skuList";
        let filter;

        if (allStatus !== null && allStatus.length > 0 && contractNumber !== null && contractNumber.length > 0) {
            filter = allFilers;
        } else if (allStatus !== null && allStatus.length > 0) {
            filter = allStatusFilter;
        } else {
            filter = `(contractorNumber eq '${vendorNumber}') and (${contractFilter}) and  
                          (FK_status eq ${STATUSES.UNASSIGNED} or FK_status eq ${STATUSES.ASSIGNED} or FK_status eq ${STATUSES.ENROUTE} or
                              FK_status eq ${STATUSES.ONSITE} or FK_status eq ${STATUSES.PENDING_REVIEW} or FK_status eq ${STATUSES.BELL_BILLING_APPROVAL} or 
                              FK_status eq ${STATUSES.BILLING_ADJUSTMENT} or FK_status eq ${STATUSES.BILLING_APPROVED} or FK_status eq ${STATUSES.CLOSED} or
                              FK_status eq ${STATUSES.INCOMPLETE} or FK_status eq ${STATUSES.CANCELLED} or FK_status eq ${STATUSES.RAP_REQUESTED}) and displayTask eq true `;
        }

        requestInit.body = JSON.stringify(payload);
        let fetchUrl = "/api/fetchTasks";
        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalODataFetch(process.env.REACT_APP_TASK_API_URL + fetchUrl, requestInit);
    },

    getTasksForTechnician: (token, technicianId) => {
        const requestInit = {
            // method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
                "bell_businessKey": technicianId

            },
        };

        const expand = "resourceAssignedTo,status,priority,workType,workActivity,centralOffice,completionCode";
        const filter =
            `(FK_resourceAssignedTo eq ${technicianId}) and ` +
            `(FK_status eq ${STATUSES.ASSIGNED} or FK_status eq ${STATUSES.ENROUTE} or FK_status eq ${STATUSES.ONSITE}) and displayTask eq true`;
        var URI = `/Tasks?$expand=${expand}&$filter=${filter}`;

        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalODataFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },

    getIndWorkOrder: (token, workOrderNum, vendorNumber, withSKUs, withPermits, isLabourer) => {
        if (isLabourer) {
            const requestInit = {
                // method: 'GET', // *GET, POST, PUT, DELETE, etc.
                // mode: 'same-origin', // no-cors, cors, *same-origin
                cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                credentials: "include", // include, *same-origin, omit
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                    Accept: "application/json",
                },
            };
            // TODO: ADD FOLLOW UPS TO THIS, IF POSSIBLE
            const expand =
                "workOrderDetail/sapWorkOrderPOList/sapPurchaseOrder,workOrderDetail/followUps/followUpTpyeId,workOrderDetail/billingList,resourceAssignedTo,status,reasonCode,subReasonCode,priority,workType,workActivity,workOrderActivity,completionCode," +
                "workOrderDetail/technicianDetails,workOrderDetail/jobClassification,workOrderDetail/csType,workOrderDetail/workOrderReason,workOrderDetail/followUps/acutRelatedId,workOrderDetail/additionalAction,plantType,workOrderDetail/plantTypeDetails" +
                (withSKUs ? ",skuList,reasonCode,subReasonCode,locates" : "") +
                (withPermits ? ",permits" : "");
            const URI = `/Tasks?$expand=${expand}&$filter=(contractorNumber eq '${vendorNumber}') and workOrderDetail/workOrderId eq '${workOrderNum}'`;

            // This needs to not be awaited.  It causes problems when calling it from the saga
            return internalODataFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
        } else {
            const requestInit = {
                method: "PATCH", // *GET, POST, PUT, DELETE, etc.
                mode: "same-origin", // no-cors, cors, *same-origin
                cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                credentials: "include", // include, *same-origin, omit
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                    Accept: "application/json",
                },
            };
            const payload = {
                contractorNumber: vendorNumber,
                workOrderNumber: workOrderNum,
            };
            // TODO: ADD FOLLOW UPS TO THIS, IF POSSIBLE
            // const expand = 'workOrderDetail/sapWorkOrderPOList/sapPurchaseOrder,workOrderDetail/followUps/followUpTpyeId,workOrderDetail/billingList,resourceAssignedTo,status,reasonCode,subReasonCode,priority,workType,workActivity,workOrderActivity,' +
            // 'workOrderDetail/technicianDetails,workOrderDetail/jobClassification,workOrderDetail/csType,workOrderDetail/workOrderReason,workOrderDetail/followUps/acutRelatedId,workOrderDetail/additionalAction,plantType,workOrderDetail/plantTypeDetails' +
            // (withSKUs ? ',skuList,reasonCode,subReasonCode,locates' : '') + (withPermits ? ',permits' : '');
            // const URI = `/Tasks?$expand=${expand}&$filter=(contractorNumber eq '${vendorNumber}') and workOrderDetail/workOrderId eq '${workOrderNum}'`

            // // This needs to not be awaited.  It causes problems when calling it from the saga
            // return internalODataFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);

            requestInit.body = JSON.stringify(payload);
            let fetchUrl = "/api/fetchTasks";
            // This needs to not be awaited.  It causes problems when calling it from the saga
            return internalODataFetch(process.env.REACT_APP_TASK_API_URL + fetchUrl, requestInit);
        }
    },

    getIndWorkOrderInfo: (token, workOrderNum) => {
        const requestInit = {
            // method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        return internalODataFetch(
            `${process.env.REACT_APP_TASK_API_URL}/WorkOrderDetails?$expand=csType,jobClassification,workOrderReason&$filter=workOrderId eq '${workOrderNum}'`,
            requestInit,
        );
    },

    getConfinedSpaceInfo: (token, confinedSpaceNum) => {
        const requestInit = {
            // method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-ifS-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        return internalODataFetch(
            `${process.env.REACT_APP_TASK_API_URL}/ConfinedSpaces?$expand=confinedSpaceTypeId&$filter=id eq ${confinedSpaceNum}`,
            requestInit,
        );
    },

    getTaskCounts: (token, vendorNumber, contractNumber, allStatus, creationDateObject, workOrderNumber) => {
        const requestInit = {
            method: "PATCH", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        let payload = { contractorNumber: vendorNumber };
        let contractQuery = "";
        if (contractNumber != null && contractNumber.length > 0) {
            contractNumber.forEach((el, index) => {
                let contractValue = index === contractNumber.length - 1 ? `${el}` : `${el},`;
                contractQuery += contractValue;
            });
            payload["contractNumber"] = contractQuery;
        }
        let statusQuery = "";
        if (allStatus !== null && allStatus.length > 0) {
            allStatus.forEach((el, index) => {
                let statusValue = index === allStatus.length - 1 ? `${el}` : `${el},`;
                statusQuery += statusValue;
            });
            payload.status = statusQuery;
        }
        if (creationDateObject.fromDate !== "" && creationDateObject.fromDate !== null) {
            payload.fromDate = moment(creationDateObject.fromDate).format("YYYY-MM-DD");
        } else {
            payload.fromDate = moment(new Date()).add(-1, "year").format("YYYY-MM-DD");
        }
        if (creationDateObject.toDate !== "" && creationDateObject.toDate !== null) {
            payload.toDate = moment(creationDateObject.toDate).format("YYYY-MM-DD");
        }
        if (workOrderNumber) {
            payload.workOrderNumber = workOrderNumber;
        }

        requestInit.body = JSON.stringify(payload);
        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalFetch(process.env.REACT_APP_TASK_API_URL + "/TasksCountDetails", requestInit).then(({ err, result }) => {
            if (err === null) {
                result = result.body;
            }
            return { err, result };
        });
    },

    assignTask: (token, assignment, username) => {
        assignment["userName"] = username;
        const requestInit = {
            body: JSON.stringify(assignment),
            method: "PATCH", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };

        return internalFetch(process.env.REACT_APP_TASK_API_URL + "/assignTask/" + assignment.workOrderNumber, requestInit);
    },

    taskAction: (token, data, action, username) => {
        const requestInit = {
            body: action === "completeTask" ? JSON.stringify(data) : JSON.stringify({ workOrderNumber: data, userName: username }),
            method: "PATCH", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };

        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalFetch(process.env.REACT_APP_TASK_API_URL + "/" + action, requestInit);
    },

    taskPatch: (token, taskId, patchDetails) => {
        const requestInit = {
            body: JSON.stringify(patchDetails),
            method: "PATCH", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };

        const URI = `/Tasks(${taskId})`;

        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },

    getBillingActivitiesOld: (token, billingActivitiesRequest) => {
        const requestInit = {
            // method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalODataFetch(
            process.env.REACT_APP_TASK_API_URL +
                "/ContractProducts?$format=json&$filter=contractNumber eq '" +
                billingActivitiesRequest.contractNumber +
                "' ",
            requestInit,
        );
    },
    getBillingActivities: (token, billingActivitiesRequest) => {
        const requestInit = {
            body: JSON.stringify(billingActivitiesRequest),
            method: "PATCH", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        return internalFetch(process.env.REACT_APP_TASK_API_URL + "/billingActivities", requestInit);
    },
    getVendorManager: (token, args) => {
        const requestInit = {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        const URI = `/getVendorManagers/${args.clliCode}/${args.workActivityId}`;
        return internalFetch(process.env.REACT_APP_TECHNICIAN_API_URL + URI, requestInit);
        // var URI = `/getVendorManagers?clliCode=${args.clliCode}&workActivityId=${args.workActivityId}`
        // // This needs to not be awaited.  It causes problems when calling it from the saga
        // return internalFetch(process.env.REACT_APP_TECHNICIAN_API_URL + URI, requestInit)
    },
    saveBillingActivities: (token, saveBillingRequest) => {
        const requestInit = {
            body: JSON.stringify(saveBillingRequest),
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        return internalFetch(process.env.REACT_APP_TASK_API_URL + "/sku", requestInit);
    },

    savePermitInfos: (token, permitInfoBody, userName) => {
        const requestInit = {
            body: JSON.stringify(permitInfoBody),
            method: "PATCH", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
                originatingSystem: "CMIS",
                username: userName,
            },
        };
        return internalFetch(process.env.REACT_APP_TASK_API_URL + "/createUpdateDeletePermit", requestInit);
    },

    getReasonCodes: (token) => {
        const requestInit = {
            // method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        var URI = `/ReasonCodes?$expand=status`;

        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalODataFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },

    incompleteTaskWithReason: (token, data) => {
        const requestInit = {
            body: JSON.stringify(data),
            method: "PATCH", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };

        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalFetch(process.env.REACT_APP_TASK_API_URL + "/incompleteTaskWithReason", requestInit);
    },

    getReasons: (token) => {
        const requestInit = {
            // method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalODataFetch(process.env.REACT_APP_TASK_API_URL + "/ReasonCodes", requestInit);
    },

    requestNewDueDate: (token, requestNewDueDate, username) => {
        requestNewDueDate["userName"] = username;
        const requestInit = {
            body: JSON.stringify(requestNewDueDate),
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };

        return internalFetch(process.env.REACT_APP_TASK_API_URL + "/update-rap-dueDate", requestInit);
    },

    getBillingsByWO: (token, woNumber) => {
        const requestInit = {
            // method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
                "bell_businessKey": woNumber,
            },
        };
        const filter = `workorderNumber eq '${woNumber}'`;
        var URI = `/Billings?$filter=${filter}&$top=1`;

        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalODataFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },

    saveRelatedWorkLocates: (token, saveLocatesRequest, userName) => {
        const requestInit = {
            body: JSON.stringify(saveLocatesRequest),
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
                originatingSystem: "CMIS",
                username: userName,
            },
        };
        return internalFetch(process.env.REACT_APP_TASK_API_URL + "/locate", requestInit);
    },

    getActivityQuestions: (token, activityId) => {
        const requestInit = {
            // method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        const filter = `activityID eq ${activityId}`;
        var URI = `/ActivityQuestions?$filter=${filter}`;

        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalODataFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },

    getFollowUpReasons: (token) => {
        const requestInit = {
            // method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        var URI = `/FollowUpTypes`; // TODO: URL CHANGE HERE

        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalODataFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },

    saveFollowUps: (token, saveFollowUpsRequest, workOrderNum, username) => {
        const requestInit = {
            body: JSON.stringify(saveFollowUpsRequest, { workOrderNumber: workOrderNum, userName: username }),
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        return internalFetch(process.env.REACT_APP_TASK_API_URL + "/followUp", requestInit);
    },

    //getFollowUpDewDate
    getFollowUpDewDate: (token, data) => {
        const requestInit = {
            // body: JSON.stringify(saveFollowUpsRequest, { "workOrderNumber": workOrderNum, "userName": username }),
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
                "bell_businessKey": data.workOrderNumber,
            },
        };
        return internalFetch(process.env.REACT_APP_TASK_API_URL + `/getDueDate/${data.workOrderNumber},${data.reasonCode}`, requestInit);
    },

    // getBillingComments
    getBillingComments: (token, workOrderId) => {
        const requestInit = {
            // method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        var URI = `/Comments?$expand=commentType,reasonCode,subReasonCode&$filter=workOrderDetail/workOrderId eq '${workOrderId}'&$orderby=createdDate desc`;

        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalODataFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },
    //commentPatch
    commentPatch: (token, commentId, patchDetails) => {
        const requestInit = {
            body: JSON.stringify(patchDetails),
            method: "PATCH", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };

        const URI = `/Comments(${commentId})`;

        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },

    // addContractorComment
    addContractorComment: (token, newComment) => {
        const requestInit = {
            body: JSON.stringify(newComment),
            method: "PATCH", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        return internalFetch(process.env.REACT_APP_TASK_API_URL + "/createUpdateDeleteComments", requestInit);
    },

    getAdditionalAction: (token) => {
        const requestInit = {
            // method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        var URI = `/AdditionalActions`; // TODO: URL CHANGE HERE

        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalODataFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },
    saveAdditionalAction: (token, saveAdditionalActions) => {
        const requestInit = {
            body: JSON.stringify(saveAdditionalActions),
            method: "PATCH", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        return internalFetch(process.env.REACT_APP_TASK_API_URL + "/additionalAction", requestInit);
    },
    getAssignmentInformation: (token, phoneNumber) => {
        const requestInit = {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
                "bell_businessKey": phoneNumber?.replaceAll("-", ""),
            },
        };
        let phoneValue = phoneNumber?.replaceAll("-", "");
        return internalODataFetch(process.env.REACT_APP_TASK_API_URL + "/assignmentInformantion/" + phoneValue, requestInit);
    },
    getMultipleWorkActivityInformation: (token, workOrderNumber) => {
        const requestInit = {
            method: "GET", // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
                "bell_businessKey": workOrderNumber,
            },
        };
        var URI = `/getWorkOrderActivity/${workOrderNumber}`;
        return internalFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },

    getRelatedWO: (token, relatedId) => {
        const requestInit = {
            // method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        // TODO: ADD FOLLOW UPS TO THIS, IF POSSIBLE
        const expand =
            "tasks/workType,status,workOrderReason,workOrderActivity/activity,tasks/status,technicianDetails,jobClassification,plantTypeDetails,tasks/permits,followUps,followUps/acutRelatedId,followUps/followUpTpyeId,tasks/skuList,additionalAction,billingList,sapWorkOrderPOList,tasks/resourceAssignedTo,tasks/reasonCode,tasks/subReasonCode,csType,priority,tasks/locates,tasks/noTemp,tasks/priority,tasks/completionCode,sapWorkOrderPOList/sapPurchaseOrder,tasks/skuList/billingReasonCode";
        const URI = `/WorkOrderDetails?$expand=${expand}&$filter=relatedId  eq '${relatedId}'`;
        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalODataFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },
    getOrderedRelatedData: (token, relatedId, workOrderId) => {
        const requestInit = {
            // method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
                "bell_businessKey": workOrderId,
            },
        };
        const URI = `/getRelatedWorkOrderInfo/${relatedId},${workOrderId}`;

        return internalODataFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },
    getAllStatus: (token, vendorNumber, keycloakID) => {
        const requestInit = {
            method: "GET",
            redirect: "follow",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
                "bell_businessKey": vendorNumber,
            },
        };
        const URI = `/getAllStatusFromTasks/${vendorNumber}/${keycloakID}`;
        return internalFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit).then(({ err, result }) => {
            if (err === null) {
                result = result.body;
            }
            return { err, result };
        });
    },
    getUserNameDetail: (token, userName) => {
        const requestInit = {
            method: "GET",
            // redirect: 'follow',
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        const URI = `/Technicians?$filter=userName eq '${userName}'&$format=json`;
        return internalODataFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },
    getCancelWorkorderReason: (token, workorderNumber, contractorNumber) => {
        const requestInit = {
            method: "GET",
            cache: "no-cache",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
                "bell_businessKey": workorderNumber,
            },
        };
        const filter = `workOrderDetail/workOrderId eq '${workorderNumber}' and workOrderDetail/tasks/contractorNumber eq '${contractorNumber}'`;
        const URI = `/Comments?$filter=${filter} and reasonCode/reasonCodeType eq 'Cancelled' &$orderby=id desc&$format=json&$expand=reasonCode&$top=1`;
        return internalFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },
    getCompleteCodeReasons: (token) => {
        const requestInit = {
            // method: 'GET', // *GET, POST, PUT, DELETE, etc.
            // mode: 'same-origin', // no-cors, cors, *same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            credentials: "include", // include, *same-origin, omit
            headers: {
                "Content-Type": "application/json",
                "x-access-token": token,
                Accept: "application/json",
            },
        };
        const URI = `/ReasonCodes?$filter=reasonCodeType eq 'Complete' and displayReason eq true &$format=json&$expand=status`;
        // This needs to not be awaited.  It causes problems when calling it from the saga
        return internalODataFetch(process.env.REACT_APP_TASK_API_URL + URI, requestInit);
    },
};
export default taskServices;
